import { PureComponent } from "react";
import colors from "/styles/colors";
import PictureComponent from "/components/core/picture/picture-component";
import classnames from "classnames";
import { componentStyles } from "./quote-component.scss";

export default class QuoteComponent extends PureComponent {
  render() {
    const { activeQuote, aboveTheFold } = this.props;
    const { personImage, personTitle, quoteText, title, color } = activeQuote;

    return (
      <div className="quote-component">
        <div className={classnames("quote-component-inner", { "above-the-fold": aboveTheFold })}>
          <div className="person-image-section">
            <PictureComponent
              className="person-image"
              src={personImage}
              extraCloudinaryTransformations={{ height: 100, width: 100 }}
            />
          </div>
          <div className="person-text-setcion">
            <div className="title" style={{ color: colors[color] }}>
              {title}
            </div>
            <div className="person-quote">{quoteText}</div>
            <div className="person-title">{personTitle}</div>
          </div>
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
